import CustomFilterSelect from "./CustomFilterSelect";

const FilterBorrowerAcceptance = (props: any) => {
  const FilterData = [
    // { id: "N/A", name: "N/A" },
    { id: "Pending", name: "Pending" },
    // { id: "Expired", name: "Expired" },removed it , add new column Expired
    { id: "Accept", name: "Accepted" },
  ];
  const authrole = localStorage?.getItem("authrole")?.toString();
  return (
    <CustomFilterSelect
      source="sApplicationResponse"
      label="Borrower Acceptance"
      choices={FilterData}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterBorrowerAcceptance;
